export default __webpack_public_path__ + "static/media/light.85073445.svg";